module.exports = __webpack_public_path__ + "media/images/donation-popup-bg-5b2fb37021d8617bd0544321eba0432b.png";